<div class="container-warn">
	<div>
		<img src="assets/icons/warn-fraud.svg" alt="warn-fraud" />
	</div>

	<div class="container-texto">
		<span>{{ 'warn_fraud.text_1' | translate }}</span>
		<br />
		<span *ngIf="entornoActual"
			>{{ 'warn_fraud.text_2' | translate }}
			<a href="https://apps.yacare.com/#/login">{{ 'warn_fraud.yacare_link' | translate }}</a></span
		>
		<span *ngIf="!entornoActual"
			>{{ 'warn_fraud.text_2' | translate }}
			<a href="https://apps.demo.yacare.com/#/login">{{ 'warn_fraud.yacare_link_1' | translate }}</a></span
		>
	</div>
</div>
